import $axios from "../../api";

// MODULE NAME
const module = "website/referral";

const state = () => ({
  isLoading: false,
  isErrors: "",
  page: 1,
  isSuccess: false,
  list: null,
  detail: null,
});

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  ASSIGN_ERRORS(state, payload) {
    state.isErrors = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
  SET_IS_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
  SET_DETAIL(state, payload) {
    state.detail = payload;
  },
};

const actions = {
  async getList({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    try {
      const res = await $axios.get(
        `${module}/list?page=${state.page}&view=${rootState.Main.view}${
          payload || ""
        }`
      );
      commit("SET_LIST", res.data.data);
      return res.data;
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, {
        root: true,
      });
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },
  async getDetail({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    try {
      const res = await $axios.get(`${module}/view`, { 
        params: 
        { 
          referrer_id: payload 
        } 
      });
      commit("SET_DETAIL", res.data.data);
      return res.data;
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, {
        root: true,
      });
      return {};
    } finally {
      commit("SET_LOADING", false);
    }
  },
  async create({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("SET_IS_SUCCESS", false);
    try {
      const res = await $axios.put(`${module}/create`, payload);
      commit("SET_IS_SUCCESS", true);
      return res.data;
    } catch (error) {
      commit("ASSIGN_ERRORS", error.response?.data?.errors || "");
      dispatch("Main/globalSweetAlert", error.response, {
        root: true,
      });
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },
  async showHide({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("SET_IS_SUCCESS", false);
    try {
      const res = await $axios.post(`${module}/showhide`, { id: payload });
      commit("SET_IS_SUCCESS", true);
      return res.data;
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, {
        root: true,
      });
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
